import { requestMenuUsers } from './ajax';
import type { LoadingStore } from 'ehs-react';
import { createStore, showError } from 'ehs-react';
import { PortletStoreApi } from '../App';
import type { icModel } from 'generated-ts-common';
type MenuUser = icModel.saf.infrastructure.model.menu.MenuUser;

export interface MenuUserStore extends LoadingStore<void> {
  /** The MenuUsers. */
  users: Array<MenuUser>;
}

/**
 * A sample ajax store containing pizzas and an ingredient used for filtering the pizzas.
 */
export const [useUserMenuStore, UserMenuStoreApi] = createStore<MenuUserStore>(
  'menuUser.store',
  set => ({
    users: [],
    loading: false,
    wasLoaded: false,

    /**
     * Async ajax request to load pizzas and populate the store.
     *
     * Don't forget to do error handling on the promise!
     *
     * @param options the ingredient to filter for
     */
    load: async (): Promise<void> => {
      const response = await requestMenuUsers({
        url: PortletStoreApi.getState().url,
        setLoading: loading => set({ loading: loading })
      }).catch(showError);

      if (!response) return;
      const users = response.data;

      // update the store
      set({ users: users, wasLoaded: true }, 'load');
    }
  })
);
